import { capitalize } from "./capitalize";

export const camelCaseToWords = (s: string): string =>
	capitalize(s.replace(/[A-Z]/g, (c) => ` ${c.toLowerCase()}`));
